import { UpdateReferenceTypes, } from '@debbie/common/dist/updates/index.js';
import { debounce } from '@debbie/common/dist/util/index.js';
import { prefetchCaseData } from '@debbie/cortex/dist/cases/index.js';
import { c } from '@debbie/cortex/dist/index.js';
import moment from 'moment';
import React from 'react';
import { styled } from 'styled-components';
import THEME from '../../theme.js';
import Checkbox from '../Checkbox.js';
import UserPreview from '../UserPreview.js';
const ListItem = (props) => {
    const { update, updateType, selected, usersOnCaseMap, checked, onCheck } = props;
    return (React.createElement(ListItemStyled, { onMouseEnter: () => {
            debounce(`todo-queue-hover-${update.referenceId}'`, () => {
                prefetchCaseData(update.referenceId);
            }, 200);
        }, onMouseLeave: () => {
            debounce(`todo-queue-hover-${update.referenceId}'`, () => { }, 0);
        }, onClick: () => {
            props.setClickedNext(false);
            c.redirect.redirect(`/todo-queue/${updateType.updateTypeId}/${update.referenceId}`, { preserveQuery: true });
        }, selected: selected }, (() => {
        switch (update.type) {
            case UpdateReferenceTypes.CASE:
                const usersOnCase = usersOnCaseMap[update.details.caseSeqId];
                return (React.createElement(React.Fragment, null,
                    React.createElement(Checkbox, { checkMark: true, checkboxStyle: {
                            fontSize: '16px',
                        }, checked: checked, onChange: (e) => {
                            onCheck(e.target.checked);
                        }, style: { alignSelf: 'flex-start' } }),
                    React.createElement("div", null,
                        React.createElement("div", { style: {
                                float: 'right',
                                paddingLeft: '10px',
                            } }, usersOnCase &&
                            usersOnCase.map(({ user }) => (React.createElement(UserPreview, { key: user.id, user: user, tooltipToLeft: true })))),
                        React.createElement("h4", { style: {
                                margin: '0 0 0.1em',
                                textOverflow: 'ellipsis',
                                overflow: 'hidden',
                                whiteSpace: 'nowrap',
                            } }, update.details.debtorNames),
                        React.createElement("p", { style: {
                                margin: '0',
                                fontSize: '0.8em',
                                textOverflow: 'ellipsis',
                                overflow: 'hidden',
                                whiteSpace: 'nowrap',
                            } }, update.details.creditorName),
                        React.createElement("p", { style: {
                                margin: '0',
                                fontSize: '0.8em',
                                textOverflow: 'ellipsis',
                                overflow: 'hidden',
                                whiteSpace: 'nowrap',
                            } }, moment(update.pausedAt).format('DD/MM/YY H:mm:ss')))));
            default:
                return null;
        }
    })()));
};
export default ListItem;
const ListItemStyled = styled.div `
  display: flex;

  padding: ${(props) => (props.selected ? '8px 0 8px 0px' : '8px 0 8px 0px')};
  border-right: ${(props) => props.selected ? `3px solid ${THEME.COLOR_ACCENT}` : 'none'};
  border-bottom: 1px solid lightgrey;

  &:first-child {
    border-top: 1px solid lightgrey;
  }

  cursor: pointer;
`;
//# sourceMappingURL=ListItem.js.map